/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Go_To_Event_StartInputs */



/**
* | output |
* | --- |
* | "Go To Start Of Event" |
*
* @param {Shortcut_Keys_Name_Go_To_Event_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_go_to_event_start = /** @type {((inputs?: Shortcut_Keys_Name_Go_To_Event_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Go_To_Event_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aller au debut de l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gehe zum Start des Ereignisses")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai all'inizio dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти к началу мероприятия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ir al inicio del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("前往活动开始处")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの開始へ移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट की शुरुआत पर जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ir para o início do evento")
	return /** @type {LocalizedString} */ ("Go To Start Of Event")
});